import { NodeUtils, EditorUtils } from '@ssml-editor/vue';
import { PHONEME_TYPE } from './constant.js';

const phonemePlugin = (editor) => {
  const { isInline, isVoid, insertNode } = editor;
  const newEditor = editor;
  newEditor.isInline = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === PHONEME_TYPE) return true;
    return isInline(element);
  };
  newEditor.isVoid = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === PHONEME_TYPE) return false;
    return isVoid(element);
  };
  newEditor.insertNode = (node) => {
    const type = NodeUtils.getNodeType(node);
    if (type === PHONEME_TYPE && newEditor.selection) {
      EditorUtils.insertSpace(newEditor, newEditor.selection);
    }
    insertNode(node);
  };
  return newEditor;
};

export { phonemePlugin };
//# sourceMappingURL=plugin.js.map
